import { cn } from "@/lib/utils/cn";

export const wizardSectionShellClass =
  "rounded-control border border-card-border bg-surface-primary p-ds-5 shadow-card";

export const wizardSectionShellDenseClass =
  "rounded-control border border-card-border bg-surface-secondary p-ds-4";

export const wizardFieldClass =
  "ui-control h-10 min-h-10 w-full rounded-control text-caption text-foreground placeholder:text-muted";

export const wizardTextareaClass =
  "ui-control min-h-[5rem] w-full resize-y rounded-control text-caption text-foreground placeholder:text-muted";

/** Section eyebrow — short label above a card title */
export const wizardLabelClass = "form-label";

export const wizardKickerClass = "text-micro font-semibold uppercase tracking-[0.1em] text-primary";

export const wizardIconBoxClass =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-control border border-primary/15 bg-primary/10 text-primary";

export const wizardInvalidInputClass =
  "!border-error !bg-error/5 !text-foreground !shadow-none !ring-0 focus:!border-error focus:!ring-0 focus-visible:!border-error focus-visible:!shadow-none";

export function wizardToggleCardClass(checked: boolean) {
  return cn(
    "flex items-start gap-ds-3 rounded-control border px-ds-4 py-ds-3 transition-colors",
    checked
      ? "border-primary/20 bg-primary/8"
      : "border-card-border bg-card hover:border-border hover:bg-muted-bg/20",
  );
}
